"use client";

import React, { createContext, useContext } from "react";
import { QueryProviders, ReduxProviders } from "@/redux/Providers";
import ProvidersSession from "@/app/providersSession";
import type { Session } from "next-auth";
import type { CheckoutActorContext } from "@/interface/checkout/OrderData";

const defaultCheckoutActorContext: CheckoutActorContext = {
    mode: "guest",
    customerSession: null,
    operatorSession: null,
    operatorMeta: {
        code: null,
        leadNumber: null,
    },
};

const CheckoutActorContextState = createContext<CheckoutActorContext>(defaultCheckoutActorContext);

interface RouteProvidersProps {
    children: React.ReactNode;
    withQuery?: boolean;
    withRedux?: boolean;
    withSession?: boolean;
    session?: Session | null;
    checkoutActorContext?: CheckoutActorContext;
}

export function useCheckoutActorContext() {
    return useContext(CheckoutActorContextState);
}

export default function RouteProviders({
    children,
    withQuery = false,
    withRedux = false,
    withSession = false,
    session = null,
    checkoutActorContext = defaultCheckoutActorContext,
}: RouteProvidersProps) {
    let content = children;

    if (withSession) {
        content = <ProvidersSession session={session}>{content}</ProvidersSession>;
    }

    if (withRedux) {
        content = <ReduxProviders>{content}</ReduxProviders>;
    }

    if (withQuery) {
        content = <QueryProviders>{content}</QueryProviders>;
    }

    return (
        <CheckoutActorContextState.Provider value={checkoutActorContext}>
            {content}
        </CheckoutActorContextState.Provider>
    );
}
